import { render } from "./DiveLoader.vue?vue&type=template&id=12c0fac6&scoped=true"
import script from "./DiveLoader.vue?vue&type=script&lang=js"
export * from "./DiveLoader.vue?vue&type=script&lang=js"

import "./DiveLoader.vue?vue&type=style&index=0&id=12c0fac6&scoped=true&lang=css"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c0fac6"]])

export default __exports__